"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = require("../../Styling");
var GlobalClassNames = {
    host: 'ms-HoverCard-host'
};
function getStyles(props) {
    var className = props.className, theme = props.theme;
    var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
    return {
        host: [classNames.host, className]
    };
}
exports.getStyles = getStyles;
//# sourceMappingURL=HoverCard.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/HoverCard/HoverCard.styles.js
// module id = 1055
// module chunks = 0